<template>
  <v-dialog :value="true" persistent max-width="550">
    <v-card style="display: flex; flex-direction: column; min-height: 420px">
      <v-card-title class="justify-center">
        <v-row justify="center" class="my-2">
          <h2>{{ $t('periods.selectPeriod') }}</h2>
        </v-row>
      </v-card-title>
      <v-card-text class="body-1 pb-0" style="flex: 1">
        <v-col class="black--text">
          <p class="ma-0 mt-2 ml-3">
            {{ $t('periods.changePeriod') }}
          </p>
          <v-form ref="periodForm" v-model="validPeriodForm" lazy-validation>
            <v-col>
              <v-select
                v-model="newPeriod"
                :label="$t('periods.selectPeriod')"
                :items="availablePeriods"
                item-text="title"
                :item-value="(item) => item"
                variant="underlined"
                :rules="[notEmpty]"
                :menu-props="{ maxHeight: '200px' }"
              >
                <!-- Slot para mostrar el texto formateado en cada item -->
                <!--template v-slot:item="data">
                  {{ buildTextOption(data) }}
                </template-->
                <template v-slot:item="{ item, attrs, on }">
                  <v-list-item
                    v-bind="attrs"
                    v-on="on"
                    :style="
                      item.title === 'initialMode'
                        ? {
                            backgroundColor: $vuetify.theme.dark
                              ? '#2e7d32'
                              : '#e8f5e9',
                            color: $vuetify.theme.dark ? 'white' : 'black',
                          }
                        : {}
                    "
                  >
                    <v-list-item-title>
                      {{ buildTextOption({ item }) }}
                    </v-list-item-title>
                  </v-list-item>
                </template>

                <!-- Slot para mostrar el valor seleccionado formateado -->
                <template v-slot:selection="data">
                  {{ buildTextOption(data) }}
                </template>
              </v-select>

              <!-- Rango de fechas -->
              <v-row
                v-if="
                  newPeriod?.title == 'dateRange' ||
                  newPeriod?.unit == 'dateRange'
                "
                class="mt-4"
                align="baseline"
              >
                <template>
                  <v-col cols="6" class="mt-0 mb-2">
                    <!-- Fecha inicial  -->
                    <v-menu
                      dense
                      class="ma-0 pa-0"
                      ref="initialDateMenu"
                      v-model="initialDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="initialDate"
                          :label="`${$t('initialDate')}`"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          id="period-initial-date"
                          :rules="noRestrictionDateSelected ? [notEmpty] : []"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @click:date="
                          () => {
                            $refs.initialDateMenu.save(initialDate)
                          }
                        "
                        v-model="initialDate"
                        :locale="$t('javascriptLocale')"
                        :min="minimumDateFrom"
                        :max="maximumDate"
                        no-title
                        scrollable
                        :rules="[notEmpty]"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>

                  <!-- Fecha final  -->
                  <v-col cols="6" class="mt-0 mb-2">
                    <v-menu
                      dense
                      class="ma-0 pa-0"
                      ref="finalDateMenu"
                      v-model="finalDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="finalDate"
                          :label="`${$t('finalDate')}`"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          id="period-final-date"
                          :rules="[notEmpty]"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        @click:date="
                          () => {
                            $refs.finalDateMenu.save(finalDate)
                          }
                        "
                        v-model="finalDate"
                        :locale="$t('javascriptLocale')"
                        :min="minimumDateTo"
                        :max="maximumDate"
                        no-title
                        scrollable
                        :rules="[notEmpty]"
                        :disabled="!initialDate"
                      >
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </template>
              </v-row>
            </v-col>
          </v-form>
        </v-col>
      </v-card-text>

      <!-- mostrar mensaje de alerta a modo de aviso, excepto para la opcion de restaurar modo inicial -->
      <div
        class="mt-0"
        style="display: flex; justify-content: center; width: 100%"
        v-if="newPeriod?.title !== 'initialMode'"
      >
        <v-alert type="info" color="red" style="max-width: 80%">
          <span>{{ $t('periods.allWarning') }}</span>
        </v-alert>
      </div>

      <v-card-actions class="headline justify-center">
        <v-btn
          color="error"
          rounded
          class="white--text"
          width="150px"
          @click="cancelAction"
          id="cancel-change-period"
        >
          {{ $t('close') }}
        </v-btn>
        <v-btn
          rounded
          color="accept"
          class="white--text"
          width="150px"
          :disabled="!userCanChangePeriod || !newPeriod"
          @click="performAction"
          id="confirm-change-period"
        >
          {{ $t('confirm') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import rules from '@/utils/rules'

export default {
  props: {
    periods: Array,
    currentPeriod: Object,
  },
  async mounted() {
    if (!this.currentPeriod || typeof this.currentPeriod !== 'object') {
      this.newPeriod = this.currentPeriod
      return
    }

    // si existen, extrae initialDate y finalDate y guarda el resto en newPeriod
    const {
      initialDate: init,
      finalDate: fin,
      ...periodSinFechas
    } = this.currentPeriod

    // si existen las dos fechas, las guardamos
    if (init != null && fin != null) {
      this.initialDate = init
      this.finalDate = fin
    }
    // y asignamos al modelo del select el objeto que necesita, sin las fechas
    this.newPeriod = periodSinFechas
  },
  data() {
    return {
      newPeriod: undefined,
      validPeriodForm: false,
      initialDate: '',
      initialDateMenu: false,
      finalDate: '',
      finalDateMenu: false,
    }
  },
  methods: {
    ...mapMutations(['setSnackbar']),
    ...rules,
    closeDialog() {
      // cuando haya fechas desde-hasta hay que componer la respuesta y devolver la informacion
      const condition =
        this.newPeriod?.title == 'dateRange' ||
        this.newPeriod?.unit == 'dateRange'

      this.$emit(
        'setPeriod',
        condition
          ? {
              ...this.newPeriod,
              initialDate: this.initialDate,
              finalDate: this.finalDate,
            }
          : this.newPeriod
      )

      this.$refs.periodForm?.reset()
      this.$refs.periodForm?.resetValidation()
    },
    performAction() {
      if (!this.$refs.periodForm?.validate() || !this.userCanChangePeriod)
        return

      if (
        (this.newPeriod?.title == 'dateRange' ||
          this.newPeriod?.unit == 'dateRange') &&
        (!this.initialDate || !this.finalDate)
      ) {
        return
      }
      this.closeDialog()
    },
    cancelAction() {
      this.newPeriod = null
      this.closeDialog()
    },
    buildTextOption(data) {
      return this.$t('periods.' + data.item.title, {
        amount: data.item.amount,
        unit:
          data.item.amount == 1 && data.item.unit == 'months'
            ? this.$t('periods.month')
            : this.$t('periods.' + data.item.unit),
      })
    },
  },
  computed: {
    ...mapGetters(['isAdminUser']),
    userCanChangePeriod() {
      // de momento cualquier usuario puede cambiar, despues ya iremos viendo
      return true
    },
    availablePeriods() {
      const sortedEnabledItems = this.periods
        .filter((item) => !item.disabled) // Filtra los que no estén deshabilitados
        .sort((a, b) => a.order - b.order) // Ordena de forma ascendente por la propiedad 'order'

      return sortedEnabledItems
    },
    minimumDateFrom() {
      // por establecer algún límite inicial
      return new Date(Date.UTC(2020, 0, 1)).toISOString().substring(0, 10) // 2020-01-01
    },
    minimumDateTo() {
      if (!this.initialDate) {
        return null
      } else {
        // la fecha-hasta minima está limitada a la fecha-desde
        return new Date(this.initialDate).toISOString().substring(0, 10)
      }
    },
    maximumDate() {
      // La fecha final está limitada a la fecha actual
      return new Date().toISOString().substring(0, 10)
    },
    noRestrictionDateSelected() {
      return this.initialDate === '' && this.finalDate === ''
    },
  },
}
</script>
<style lang="scss" scoped></style>
